import React from "react";
import { UserTaskProvider } from "./context";
import { Layout } from "components/Layout/Layout";
import { FilterSection } from "./components/FilterSection";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { UserTaskDataGrid } from "./components/UserTaskDataGrid";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import { SummaryUsersTask } from "./components/SummaryUsersTask";

export const UserTaskPage = () => {
  return (
    <>
      <UserTaskProvider>
        <Layout>
          <PageTitle pageName={pageName.admin.userTask.filter} />
          <ToolbarThinWrapper />
          <FilterSection />
          <SummaryUsersTask />
          <ToolbarThinWrapper />
          <UserTaskDataGrid />
        </Layout>
      </UserTaskProvider>
    </>
  );
};
